import { FC } from 'react';
import Dsar from 'src/components/Dsar';
import withWebviewValidation from 'src/components/HOC/withWebviewValidation';
import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
const DataRequest: FC = () => {
  return <Dsar data-sentry-element="Dsar" data-sentry-component="DataRequest" data-sentry-source-file="data-request.tsx" />;
};
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default withWebviewValidation(DataRequest);